import axios from "axios";
import Store from "../../store/store.js";
import { HTTP } from "./http";

const PaymentHttp = {
    params: {
        withCredentials: true
    },
    getIsValidToken: () => {
        const token = Store.getters.pufToken;
        const url = `${config.rootApiUrl}payment/validateToken?token=${encodeURIComponent(token)}`;

        return axios.get(url, PaymentHttp.params);
    },
    verifyInformation: (data) => {            
        const formData = new FormData();
        HTTP.buildFormData(formData, data);
        const postConfig = {
            withCredentials: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "RequestVerificationToken": Store.getters.antiforgeryToken.requestToken
            }
        };
        
        const token = Store.getters.pufToken;
        const url = `${config.rootApiUrl}payment/validateIdentity?token=${encodeURIComponent(token)}`;
        return axios.post(url, formData, postConfig);
    },
    vaultPayment: (data) => {
        const postConfig = {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": Store.getters.antiforgeryToken.requestToken
            }
        };

        const token = Store.getters.pufToken;
        const url = `${config.rootApiUrl}payment/vaultPayment?token=${encodeURIComponent(token)}`;
        return axios.post(url, JSON.stringify(data), postConfig);
    },
    refreshXifinToken: () => {
        const token = Store.getters.pufToken;
        const url = `${config.rootApiUrl}payment/refreshXifinToken?token=${encodeURIComponent(token)}`;
        return axios.get(url);
    },
    xifinPaymentCompleted: (data) => {
        const postConfig = {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": Store.getters.antiforgeryToken.requestToken
            }
        };

        const token = Store.getters.pufToken;
        const url = `${config.rootApiUrl}payment/paymentCompleted?token=${encodeURIComponent(token)}`;
        return axios.post(url, JSON.stringify(data), postConfig);
    }
};

export default PaymentHttp;
